export default "__VITE_ASSET__00f915f2__"